module.exports = __webpack_public_path__ + "static/OzoneAI-65d5762822ae27ce346515296e64f873.jpg";